import React from 'react'
import { Button, Col, Form, FormFeedback, FormGroup, Input, Label, ModalBody, ModalFooter, Row } from 'reactstrap';

export const FormInvoiceSettings = (props) => {

    const {
        toggle, loading, button,
        id_type_document, code, serie, initial_folio, final_folio, is_default, is_fiscal, validationInvoiceSettings,
        listTypeDocuments, 
        handleInputChange,
        methodAction
    } = props;

    const {
        id_type_document_valid,
        code_valid,
        serie_valid,
        initial_folio_valid,
        final_folio_valid,     
    } = validationInvoiceSettings;

    return (
        <Form className='theme-form formInvoiceModern' role="form" onSubmit={methodAction}>

            {/* DATOS GENERALES */}
            <div className='cardInvoiceSection'>

                <Row className='g-2'>

                    <Col md="6">
                        <FormGroup className='mb-2'>

                            <Label className='labelInvoice'>
                                Tipo de documento
                                <span className='requiredInvoice'>*</span>
                            </Label>

                            <Input
                                type='select'
                                name='id_type_document'
                                value={id_type_document}
                                required={true}
                                onChange={handleInputChange}
                                invalid={id_type_document_valid}
                                className="inputInvoice"
                            >
                                <option value={0}>
                                    Selecciona una opción
                                </option>

                                {
                                    listTypeDocuments.length > 0 &&
                                    listTypeDocuments.map(obj => (
                                        <option
                                            value={obj.id_type_document}
                                            key={obj.id_type_document}
                                        >
                                            {obj.name}
                                        </option>
                                    ))
                                }

                            </Input>

                        </FormGroup>
                    </Col>

                    <Col md="6">

                        <FormGroup className='mb-2'>

                            <Label className='labelInvoice'>
                                Código
                                <span className='requiredInvoice'>*</span>
                            </Label>

                            <Input
                                type="text"
                                name="code"
                                value={code}
                                autoComplete="off"
                                onChange={handleInputChange}
                                invalid={code_valid}
                                className="inputInvoice"
                                
                            />

                            <FormFeedback>
                                Debes completar este campo
                            </FormFeedback>

                        </FormGroup>

                    </Col>

                </Row>

                <Row className='g-2 mt-1'>

                    <Col md="6">

                        <FormGroup className='mb-2'>

                            <Label className='labelInvoice'>
                                Serie
                                <span className='requiredInvoice'>*</span>
                            </Label>

                            <Input
                                type='text'
                                name='serie'
                                value={serie}
                                onChange={handleInputChange}
                                invalid={serie_valid}
                                className="inputInvoice"
                                placeholder='Ej. A'
                            />

                            <FormFeedback>
                                Debes capturar este campo
                            </FormFeedback>

                        </FormGroup>

                    </Col>

                    <Col md="6">

                        <FormGroup className='mb-2'>

                            <Label className='labelInvoice'>
                                Folio inicial
                                <span className='requiredInvoice'>*</span>
                            </Label>

                            <Input
                                type='number'
                                name='initial_folio'
                                value={initial_folio}
                                onChange={handleInputChange}
                                invalid={initial_folio_valid}
                                className="inputInvoice"
                                placeholder='Ej. 1000'
                            />

                            <FormFeedback>
                                Debes capturar este campo
                            </FormFeedback>

                        </FormGroup>

                    </Col>

                </Row>

            </div>

            {/* CONFIGURACIONES */}
            <div className='cardInvoiceSection mt-3'>

                <Row className='g-3'>

                    <Col md="6">

                        <div className='switchCardInvoice'>

                            <div>
                                <div className='switchTitle'>
                                    Serie por defecto
                                </div>

                                <small className='switchDescription'>
                                    Usar automáticamente
                                </small>
                            </div>

                            <Label className='switch mb-0'>
                                <Input
                                    type='checkbox'
                                    name='is_default'
                                    onChange={handleInputChange}
                                    checked={is_default}
                                />

                                <span className='slider round'></span>
                            </Label>

                        </div>

                    </Col>

                    <Col md="6">

                        <div className='switchCardInvoice'>

                            <div>
                                <div className='switchTitle'>
                                    Serie fiscal
                                </div>

                                <small className='switchDescription'>
                                    Identificar como serie fiscal
                                </small>
                            </div>

                            <Label className='switch mb-0'>
                                <Input
                                    type='checkbox'
                                    name='is_fiscal'
                                    onChange={handleInputChange}
                                    checked={is_fiscal}
                                />

                                <span className='slider round'></span>
                            </Label>

                        </div>

                    </Col>

                </Row>

            </div>

        </Form>
    )
}
